// removed by extract-text-webpack-plugin
module.exports = {"container":"_3PKBGJcOh4C6oYkwp9iInT","rotate":"_3FhygPvIWUVMD5fmP2m8iq","show":"_3KM4adQBOCA0pc7G0lGrrC","text":"ABKUboUdcV6JEeahX5rrC"};